import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import {Body, H3} from "@irati/ui/src/Typography"
import {Col} from "@irati/ui/src/Layout"

import {DesktopOnlyButton} from "../styled"

import {EmptyRows} from "./styled"

interface Props {
  onClick: () => void
}

const EmptyCompanyNews: FC<Props> = ({onClick}) => (
  <EmptyRows>
    <H3 marginBottom={1}>
      <FormattedMessage id="platform.homepage.companyNews.empty.title" />
    </H3>
    <Col xsHidden smHidden>
      <Body>
        <FormattedMessage id="platform.homepage.companyNews.empty.message" />
      </Body>
    </Col>
    <Col mdHidden lgHidden>
      <Body>
        <FormattedMessage id="platform.homepage.companyNews.empty.mobileMessage" />
      </Body>
    </Col>
    <DesktopOnlyButton primary onClick={onClick} marginTop={2}>
      <FormattedMessage id="platform.homepage.companyNews.empty.cta.title" />
    </DesktopOnlyButton>
  </EmptyRows>
)

export default EmptyCompanyNews
